import { SummaryService } from "@/services/summary/summary.service";

export const useSummary = (
  analysisId: string | undefined,
  categoryPath: string | undefined,
  isCategoryValid: boolean = true,
) => {
  const { data, error, isLoading } = SummaryService.getSummary(
    analysisId,
    categoryPath,
    isCategoryValid,
  );

  return {
    summary: data,
    error,
    isLoading,
  };
};
